<template>
  <v-card class="docs">
    <v-card-title class="two-columns">
      <div class="text-h5 text-center">{{ section.name }}</div>
      <v-btn
          class="btn btn-outline"
          text
          @click="$refs['fileupload'].click()"
          :disabled="period.status === 'CLOSED'"
      >
        Импорт
      </v-btn>
    </v-card-title>
    <input
        type="file"
        multiple
        ref="fileupload"
        style="display: none"
        @change="importFile($event)"
    >
    <div class="list">
      <table>
        <thead>
        <tr>
          <th>Краткое название показателя</th>
          <th>Значение</th>
          <th>Размерность</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="indicator in section.indicators" :key="indicator.id">
          <td>
            {{ indicator.shortName }}
          </td>
          <td>
            <v-text-field
                :value="getValue(indicator.id)?.value"
                @input="setValue(indicator.id, $event)"
                type="number"
                :disabled="period.status === 'CLOSED'"
            ></v-text-field>
          </td>
          <td>
            {{ indicator.unit }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          class="btn btn-outline"
          text
          @click="$emit('close')"
      >
        Отмена
      </v-btn>
      <v-btn
          v-if="$user.role === 'ROLE_ADMIN' || $user.role === 'ROLE_VNII'"
          class="btn btn-primary"
          @click="$emit('edit', JSON.parse(JSON.stringify(localValues)))"
          :disabled="period.status === 'CLOSED'"
      >
        Сохранить изменения
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import readXlsxFile from "read-excel-file";

export default {
  name: 'ProcessMonitorParamsDialog',
  props: ['regionAndDepartmentInfo', 'section', 'values', 'period'],
  data: () => ({
    localValues: [],
  }),
  created() {
    this.localValues = JSON.parse(JSON.stringify(this.values || []));
  },
  methods: {
    truncateStr(str, n) {
      if (str.length > n) {
        return str.substring(0, n - 3) + "..." + str.substring(str.length - 6, str.length)
      }
      return str
    },
    async importFile(event) {
      let rows = await readXlsxFile(event.target.files[0])
      let row = rows[7]
      for (let i = 0; i < 12; i++) {
        this.setValue(1, i+1, row[i + 2])
      }
    },
    getValue(indicatorId) {
      return this.localValues.find(e =>
          e.indicatorId === indicatorId &&
          e.period === this.period.code &&
          e.regionCode === this.regionAndDepartmentInfo.region.code &&
          e.departmentId === this.regionAndDepartmentInfo.department?.id
      );
    },
    getValueOrCreateNew(indicatorId) {
      let value = this.getValue(indicatorId)
      if (!value) {
        value = {
          indicatorId,
          period: this.period.code,
          regionCode: this.regionAndDepartmentInfo.region.code,
          departmentId: this.regionAndDepartmentInfo.department?.id
        }
        this.localValues.push(value)
      }
      return value
    },
    setValue(indicatorId, val) {
      let value = this.getValueOrCreateNew(indicatorId)
      value.value = val
    }
  },
}
</script>

<style lang="scss">
.list {
  padding: 0 24px !important;

  table {
    th {
      min-width: 20% !important;
    }

    th, td {
      border-bottom: 0 !important;
      padding: 5px 0 !important;
      padding-right: 10px !important;

      &:last-child {
        padding-right: 0 !important;
      }
    }
  }

  .v-text-field {
    margin-top: 0;
  }

  .v-text-field:not(.v-textarea):not(.v-file-input) .v-input__slot {
    height: initial;
    margin: 0;
    padding: 5px 5px;
  }
}

.v-dialog {
  .v-card.docs {
    .v-card__title.two-columns {
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
